function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.417 66.1L55.272 48.865C58.5343 44.3131 60.2818 38.8502 60.267 33.25C60.267 18.355 48.162 6.25 33.267 6.25C18.372 6.25 6.26704 18.355 6.26704 33.25C6.26704 48.145 18.372 60.25 33.267 60.25C39.117 60.25 44.427 58.405 48.882 55.255L66.117 72.4C66.972 73.3 68.142 73.75 69.267 73.75C70.392 73.75 71.607 73.345 72.417 72.4C72.8342 71.9837 73.1652 71.4892 73.391 70.9448C73.6168 70.4004 73.733 69.8169 73.733 69.2275C73.733 68.6381 73.6168 68.0546 73.391 67.5102C73.1652 66.9658 72.8342 66.4713 72.417 66.055V66.1ZM33.267 54.4C21.612 54.4 12.117 44.905 12.117 33.25C12.117 21.595 21.612 12.1 33.267 12.1C44.922 12.1 54.417 21.595 54.417 33.25C54.417 44.905 44.922 54.4 33.267 54.4V54.4Z"
});

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/IconSearch.17e1303a.svg";
export { ForwardRef as ReactComponent };